module.exports = __webpack_public_path__ + "media/images/logo_landing-7d92fe3e3eb435658d4580f83dc68e46.png";